import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const VisitasChart = ({data}) => {
    const [options, setOptions] = useState({});
    const [series, setSeries] = useState([]);

    useEffect(() => {
        const categories = data.map(item => item.label);

        setOptions({
            chart: { type: 'bar', toolbar: { show: false } },
            plotOptions: {
                // apexcharts 4 eliminó `endingShape: 'rounded'`; su reemplazo es
                // borderRadius sobre el extremo de la barra.
                bar: {
                    horizontal: false,
                    columnWidth: '60%',
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                },
            },
            dataLabels: { enabled: false },
            stroke: { show: true,  width: 2, colors: ['transparent'] },
            xaxis: { categories },
            yaxis: {
                title: { text: 'Cantidad' },
                labels: { formatter: val => parseInt(val) },
            },
            fill: { opacity: 1 },
            tooltip: {
                y: { formatter: val => `${val} sesiones` }
            },
            legend: { show: true, position: 'top', horizontalAlign: 'center' },
            colors: ['#008FFB', '#00E396'],
        });

        const s = [];
        for (const key in data[0]) {
            if (Object.prototype.hasOwnProperty.call(data[0], key)) {
                if (key === 'label') continue;
                
                s.push({name: key, data: data.map(item => item[key])});
            }
        }

        setSeries(s);
    }, [data]);
    
    return <Chart options={options} series={series} type="bar" height={280} />;
};

export default VisitasChart;
